module.exports = __webpack_public_path__ + "img/icon_communicate.78bb529d.png";